<div class="confirm-login-container">
    <div class="data-container">
        <app-one-time-password
            (sendCode)="verify($event)"
            (resend)="resendCode()"
            (updateError)="updateError($event)"
            (updateRememberDevice)="updateRememberDevice($event)"
            [error]="authenticationService?.invalidConfirmationToken | async"
            [loading]="authenticationService?.loading | async"
            [destination]="authenticationService?.identifier | async"
            [hideResendOption]="(authenticationService.confirmationChannel | async) !== 'email'"
            [rememberDeviceCheckbox]="true"
            [communicationChannel]="authenticationService?.confirmationChannel | async"
        ></app-one-time-password>
    </div>
    <p class="copyright xxs" translate [translateParams]="{ year: year }">footer.all-rights-reserved</p>
</div>
